import ReceivedFileMessage from './FileMessage/ReceivedFileMessage';
import SentFileMessage from './FileMessage/SentFileMessage';
import { getMessageTime } from '../../../utils/time';

interface FileMessageProps {
  id: number;
  direction: string;
  created: string;
  file: FileMessageFile;
  dkb: number;
  error?: boolean;
}

export interface FileMessageFile {
  media: string;
  dname: string;
  fname: string;
  msg: string;
  lat?: string | null;
  lng?: string | null;
}

const FileMessage = ({
  id,
  direction,
  created,
  file,
  dkb,
  error
}: FileMessageProps) => {
  const { time } = getMessageTime(created);

  if (direction === 'received') {
    return (
      <ReceivedFileMessage
        id={id}
        created={created}
        time={time}
        file={file}
        dkb={dkb}
      />
    );
  } else {
    return (
      <SentFileMessage
        id={id}
        created={created}
        time={time}
        file={file}
        dkb={dkb}
        error={error}
      />
    );
  }
};

export default FileMessage;
